module.exports = __webpack_public_path__ + "img/10.569c35e0.png";